import { MyDashboardHome } from "@/components/dashboard/MyDashboardHome";

/**
 * My Dashboard — the friendly intranet "home" for every signed-in person:
 * a warm welcome, quick-link shortcuts, company announcements, upcoming
 * events, and who's around. Intentionally light on role/cert tracking —
 * those live on My Certifications and the Capability tools.
 */
export function MyDashboardPage() {
  return <MyDashboardHome />;
}
